// Share in-flight work too; failed requests can be retried on the next load.
export const createBookingLookupLoader = () => {
  let cachedKey;
  let cachedPromise;
  return (key, load) => {
    if (key !== cachedKey || !cachedPromise) {
      cachedKey = key;
      const pending = Promise.resolve().then(load).catch((error) => {
        if (cachedPromise === pending) cachedPromise = null;
        throw error;
      });
      cachedPromise = pending;
    }
    return cachedPromise;
  };
};

// Build a visible page from bounded reads. Keep overflow so cursor pagination
// never skips accessible bookings at the end of a fetched chunk.
export const loadAccessibleBookingPage = async ({
  previousPage,
  pageSize,
  fetchChunk,
  filterDocs,
  isCurrent = () => true,
}) => {
  let docs = previousPage ? [...previousPage.pendingDocs] : [];
  let lastDoc = previousPage ? previousPage.lastDoc : null;
  let exhausted = previousPage ? previousPage.exhausted : false;

  // One extra accessible document determines whether Next has any results.
  while (docs.length <= pageSize && !exhausted) {
    if (!isCurrent()) return null;
    const chunk = await fetchChunk(lastDoc);
    if (!isCurrent()) return null;
    docs.push(...filterDocs(chunk));
    if (chunk.length) lastDoc = chunk[chunk.length - 1];
    exhausted = chunk.length < pageSize;
  }

  return {
    docs: docs.slice(0, pageSize),
    pendingDocs: docs.slice(pageSize),
    lastDoc,
    exhausted,
    hasNext: docs.length > pageSize,
  };
};
